import { ScheduleColumn, TimeSlot } from '@/app/models/ScheduleColumn'

export type TimeSlotsMap = Map<ScheduleColumn['id'], TimeSlot[]>

export const columnsToTimeSlotsReducer = (carry: TimeSlotsMap, column: ScheduleColumn): TimeSlotsMap => {
  carry.set(column.id, column.timeSlots ?? [])
  return carry
}
